import { call, put, takeEvery } from "redux-saga/effects";
import { heApi } from "../../../api/category/heApi";
import { IDmHe } from "../../../model/respone/category/IDmHe";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDmHeActionIds,
  IDmHeActionTypes,
} from "../../action-types/category/IDmHeActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.he;

export function* heSaga(): any {
  yield takeEvery(eDmHeActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmHeActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDmHeActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(heApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IDmHeActionTypes): any {
  let res: IBaseRespone = yield call(heApi.SelectAll);
  let payload = action.payload as IDmHe;
  if (payload.id_he > 0) {
    res = yield call(heApi.Update, payload);
  } else {
    payload = {
      ...payload,
      quy_che: 0,
      thoi_gian_dao_tao: 0,
      isdoi_tuong_sdh: false,
      he_ngoai_truong: 0,
      nghiencuusinh: false,
    }
    res = yield call(heApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IDmHeActionTypes): any {
  const res: IBaseRespone = yield call(heApi.Delete, action.payload as number);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
